import { PublicGuidePage } from "./PublicGuidePage";

export function InstagramCommentsGuide() {
  return <PublicGuidePage kind="instagram" />;
}
